function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopfrombrazil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    overflow: "visible",
    xmlSpace: "preserve",
    baseProfile: "tiny",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.923
    },
    fill: "#00812c",
    d: "M 242.5,55.5 C 320.369,56.6562 379.203,90.3228 419,156.5C 449.938,217.662 450.271,278.996 420,340.5C 377.651,411.746 314.818,445.58 231.5,442C 160.497,432.613 108.33,396.446 75,333.5C 46.0575,268.881 49.7242,206.215 86,145.5C 123.544,90.3047 175.71,60.3047 242.5,55.5 Z M 232.5,66.5 C 296.49,62.314 349.323,84.314 391,132.5C 429.371,182.013 441.038,237.347 426,298.5C 405.665,364.835 362.165,407.668 295.5,427C 224.282,442.829 163.448,424.663 113,372.5C 72.0879,324.187 58.0879,268.854 71,206.5C 88.5397,141.959 128.706,98.1259 191.5,75C 205.081,71.0515 218.748,68.2182 232.5,66.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#fecc02",
    d: "M 243.5,89.5 C 313.328,90.9073 363.828,122.574 395,184.5C 421.493,252.338 409.66,312.504 359.5,365C 307.057,410.819 248.39,420.819 183.5,395C 123.498,364.605 92.1645,315.605 89.5,248C 91.6111,195.441 113.278,153.107 154.5,121C 181.22,102.038 210.887,91.5385 243.5,89.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#011540",
    d: "M 232.5,114.5 C 291.796,110.396 336.963,133.396 368,183.5C 394.197,235.989 390.197,285.989 356,333.5C 318.682,376.829 271.849,392.662 215.5,381C 159.013,363.513 125.513,325.68 115,267.5C 110.073,207.853 132.907,162.353 183.5,131C 198.989,122.568 215.323,117.068 232.5,114.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f5f7",
    d: "M 221.5,162.5 C 220.296,157.144 220.296,151.811 221.5,146.5C 225.891,140.147 231.891,137.981 239.5,140C 246.962,142.408 250.295,147.575 249.5,155.5C 250.417,162.752 247.417,167.586 240.5,170C 231.868,172.641 225.535,170.141 221.5,162.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eceef1",
    d: "M 284.5,164.5 C 285.81,161.601 287.143,158.601 288.5,155.5C 288.154,154.304 287.654,154.304 287,155.5C 285.807,157.886 284.64,160.22 283.5,162.5C 281.066,165.849 278.733,169.349 276.5,173C 274.169,172.843 271.836,172.343 269.5,171.5C 269.666,164.159 269.5,156.826 269,149.5C 268.209,150.745 267.709,152.078 267.5,153.5C 266.291,158.88 264.958,164.213 263.5,169.5C 260.684,169.456 258.351,168.456 256.5,166.5C 259.25,157.254 261.583,147.921 263.5,138.5C 267.5,139.167 271.5,139.833 275.5,140.5C 275.334,147.841 275.5,155.174 276,162.5C 279.375,156.915 282.875,151.415 286.5,146C 290.196,146.003 293.863,146.503 297.5,147.5C 295.717,157.082 293.05,166.416 289.5,175.5C 286.447,177.094 284.114,176.427 282.5,173.5C 283.932,170.673 284.599,167.673 284.5,164.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d1f48",
    d: "M 231.5,146.5 C 238.424,146.09 241.757,149.424 241.5,156.5C 241.182,162.313 238.182,164.48 232.5,163C 227.763,157.599 227.43,152.099 231.5,146.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f6f7",
    d: "M 195.5,152.5 C 206.137,151.467 210.47,156.133 208.5,166.5C 212.66,168.412 216.66,170.579 220.5,173C 218.252,174.914 215.752,176.414 213,177.5C 209.333,175.5 205.667,173.5 202,171.5C 201.5,171.833 201,172.167 200.5,172.5C 202.42,175.339 204.087,178.339 205.5,181.5C 203.882,183.316 201.882,184.649 199.5,185.5C 193.805,177.289 188.472,168.789 183.5,160C 187.407,157.241 191.407,154.741 195.5,152.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#637991",
    d: "M 221.5,146.5 C 220.296,151.811 220.296,157.144 221.5,162.5C 220.009,159.814 219.343,156.814 219.5,153.5C 219.667,151.5 219.833,149.5 220,147.5C 220.383,146.944 220.883,146.611 221.5,146.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8898aa",
    d: "M 269.5,171.5 C 268.833,165.5 268.167,159.5 267.5,153.5C 267.709,152.078 268.209,150.745 269,149.5C 269.5,156.826 269.666,164.159 269.5,171.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#071d46",
    d: "M 195.5,159.5 C 200.241,159.161 201.574,161.161 199.5,165.5C 198.833,165.833 198.167,166.167 197.5,166.5C 194.766,164.643 194.099,162.309 195.5,159.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#415b79",
    d: "M 284.5,164.5 C 284.672,163.508 284.338,162.842 283.5,162.5C 284.64,160.22 285.807,157.886 287,155.5C 287.654,154.304 288.154,154.304 288.5,155.5C 287.143,158.601 285.81,161.601 284.5,164.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f5f7",
    d: "M 171.5,169.5 C 173.317,170.816 174.983,172.316 176.5,174C 174.888,176.616 172.888,178.95 170.5,181C 171.766,182.983 173.432,183.983 175.5,184C 177.333,182.167 179.167,180.333 181,178.5C 182.351,180.019 183.851,181.352 185.5,182.5C 183.445,184.555 181.779,186.888 180.5,189.5C 182.688,192.522 185.355,195.022 188.5,197C 186.65,199.018 184.65,200.851 182.5,202.5C 174.842,196.174 167.508,189.508 160.5,182.5C 164.565,178.441 168.232,174.107 171.5,169.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eff1f4",
    d: "M 326.5,169.5 C 327.239,169.369 327.906,169.536 328.5,170C 333.621,174.605 337.288,180.105 339.5,186.5C 338.347,191.756 335.013,194.09 329.5,193.5C 330.112,199.724 327.279,203.057 321,203.5C 319.373,203.375 317.873,202.875 316.5,202C 312.48,198.115 308.814,193.948 305.5,189.5C 312.52,182.812 319.52,176.145 326.5,169.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#10244c",
    d: "M 327.5,180.5 C 330.966,181.109 331.966,182.942 330.5,186C 325.664,186.025 324.664,184.192 327.5,180.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#10264e",
    d: "M 318.5,187.5 C 321.987,188.445 323.32,190.778 322.5,194.5C 315.659,194.719 314.325,192.386 318.5,187.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eff1f3",
    d: "M 232.5,205.5 C 233.837,206.315 234.837,207.482 235.5,209C 239.927,209 240.427,210.167 237,212.5C 237.046,214.313 236.88,215.979 236.5,217.5C 234.5,216.167 232.5,216.167 230.5,217.5C 229.868,214.97 228.868,212.637 227.5,210.5C 230.205,209.796 231.871,208.129 232.5,205.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f4f6",
    d: "M 146.5,214.5 C 157.885,214.047 162.718,219.38 161,230.5C 163.621,231.991 166.455,232.658 169.5,232.5C 168.908,235.127 168.575,237.794 168.5,240.5C 158.442,238.819 148.442,236.819 138.5,234.5C 138.825,226.789 141.491,220.122 146.5,214.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#15254e",
    d: "M 148.5,222.5 C 152.908,222.062 154.575,224.062 153.5,228.5C 148.074,229.416 146.407,227.416 148.5,222.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eff1f4",
    d: "M 301.5,234.5 C 303.392,236.535 305.725,238.035 308.5,239C 307.192,241.355 306.192,243.855 305.5,246.5C 303.07,245.75 300.736,245.417 298.5,245.5C 299.975,242.755 299.309,240.588 296.5,239C 299.901,239.266 301.567,237.766 301.5,234.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f3f5",
    d: "M 349.5,200.5 C 350.376,200.369 351.043,200.702 351.5,201.5C 355.179,207.359 356.679,213.693 356,220.5C 351.612,225.509 346.446,226.676 340.5,224C 337.236,227.699 334.903,231.866 333.5,236.5C 343.173,239.169 352.839,241.836 362.5,244.5C 362.5,248.5 362.5,252.5 362.5,256.5C 352.5,259.5 342.5,262.5 332.5,265.5C 332.336,262.813 332.503,260.146 333,257.5C 334.085,256.707 335.252,256.04 336.5,255.5C 337.487,252.232 337.82,248.898 337.5,245.5C 335.738,245.643 334.071,245.309 332.5,244.5C 331.883,238.751 330.883,233.085 329.5,227.5C 330.664,223.827 332.831,220.827 336,218.5C 336.483,217.552 336.649,216.552 336.5,215.5C 332.615,216.905 328.615,217.905 324.5,218.5C 324.167,215.833 323.833,213.167 323.5,210.5C 332.465,207.737 341.132,204.404 349.5,200.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1a2b53",
    d: "M 346.5,210.5 C 348.722,210.559 349.722,211.725 349.5,214C 347.218,218.644 344.885,218.644 342.5,214C 343.686,212.588 345.019,211.421 346.5,210.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f5f6",
    d: "M 261.5,238.5 C 263.713,240.029 266.046,241.529 268.5,243C 266.771,244.789 266.104,246.956 266.5,249.5C 263.838,248.361 261.171,248.194 258.5,249C 259.772,246.956 259.439,245.122 257.5,243.5C 258.32,241.889 259.654,241.222 261.5,241.5C 261.5,240.5 261.5,239.5 261.5,238.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f3f5",
    d: "M 149.5,247.5 C 165.281,246.779 171.448,254.113 168,269.5C 166.01,273.49 162.843,275.99 158.5,277C 143.248,279.415 136.415,272.915 138,257.5C 140.194,252.171 144.027,248.838 149.5,247.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#09214a",
    d: "M 344.5,247.5 C 347.821,248.496 351.155,249.496 354.5,250.5C 351.554,251.653 348.554,252.653 345.5,253.5C 344.534,251.604 344.201,249.604 344.5,247.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#041943",
    d: "M 149.5,256.5 C 153.273,256.263 156.94,256.763 160.5,258C 162.51,262.341 161.51,265.675 157.5,268C 153.775,268.76 150.108,268.593 146.5,267.5C 143.325,262.712 144.325,259.046 149.5,256.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f9fa",
    d: "M 212.5,257.5 C 213.606,260.077 215.606,261.744 218.5,262.5C 217.132,264.637 216.132,266.97 215.5,269.5C 213.833,268.167 212.167,268.167 210.5,269.5C 209.868,266.97 208.868,264.637 207.5,262.5C 210.379,261.92 212.046,260.253 212.5,257.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eef0f3",
    d: "M 331.5,267.5 C 333.68,268.117 335.68,269.117 337.5,270.5C 341.14,275.973 344.973,281.306 349,286.5C 350.628,283.409 352.128,280.243 353.5,277C 356.038,276.133 358.038,276.799 359.5,279C 357.51,286.143 354.843,292.976 351.5,299.5C 350.069,299.023 348.736,298.357 347.5,297.5C 343.519,291.525 339.186,285.858 334.5,280.5C 332.765,284.039 331.432,287.706 330.5,291.5C 327.383,292.073 325.383,290.906 324.5,288C 326.343,280.97 328.676,274.137 331.5,267.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f9fa",
    d: "M 268.5,278.5 C 269.606,281.077 271.606,282.744 274.5,283.5C 273.132,285.637 272.132,287.97 271.5,290.5C 269.833,289.167 268.167,289.167 266.5,290.5C 265.868,287.97 264.868,285.637 263.5,283.5C 266.182,282.818 267.848,281.152 268.5,278.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f5f7",
    d: "M 169.5,280.5 C 170.552,280.351 171.552,280.517 172.5,281C 173.627,282.753 174.627,284.587 175.5,286.5C 172.204,288.821 168.871,291.154 165.5,293.5C 166.747,296.329 168.247,298.995 170,301.5C 173.333,299.5 176.667,297.5 180,295.5C 181.999,297.493 183.499,299.827 184.5,302.5C 175.833,307.5 167.167,312.5 158.5,317.5C 157.035,315.401 155.701,313.234 154.5,311C 157.341,308.665 160.341,306.499 163.5,304.5C 162.253,301.671 160.753,299.005 159,296.5C 155.99,298.183 152.99,299.85 150,301.5C 148.14,299.625 146.64,297.458 145.5,295C 153.73,290.392 161.73,285.559 169.5,280.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eff1f4",
    d: "M 319.5,294.5 C 328.231,299.725 336.564,305.558 344.5,312C 343.368,314.133 341.868,315.966 340,317.5C 331.377,312.443 323.21,306.776 315.5,300.5C 316.844,298.471 318.177,296.471 319.5,294.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeff2",
    d: "M 309.5,307.5 C 316.79,313.629 323.29,320.629 329,328.5C 329.269,331.28 328.102,333.446 325.5,335C 324.833,335.667 324.167,335.667 323.5,335C 318.656,329.325 313.656,323.825 308.5,318.5C 305.737,320.629 302.904,322.629 300,324.5C 297.435,323.622 296.101,321.956 296,319.5C 300.694,315.635 305.194,311.635 309.5,307.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f3f5",
    d: "M 186.5,309.5 C 193.184,309.763 198.351,312.763 202,318.5C 202.553,321.82 201.386,324.486 198.5,326.5C 196.957,323.914 195.291,321.414 193.5,319C 191.975,317.991 190.308,317.491 188.5,317.5C 189.695,321.76 190.695,326.093 191.5,330.5C 189.777,339.689 184.777,341.856 176.5,337C 173.6,334.603 171.267,331.77 169.5,328.5C 171.029,326.812 172.863,325.479 175,324.5C 176.377,326.754 177.877,328.92 179.5,331C 180.793,331.49 182.127,331.657 183.5,331.5C 182.466,327.092 181.133,322.759 179.5,318.5C 180.697,314.634 183.031,311.634 186.5,309.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eaecf0",
    d: "M 238.5,352.5 C 240.392,354.535 242.725,356.035 245.5,357C 244.313,358.019 243.313,359.186 242.5,360.5C 243.645,361.891 243.645,363.224 242.5,364.5C 240.5,363.167 238.5,363.167 236.5,364.5C 235.971,361.743 234.971,359.243 233.5,357C 236.309,356.688 237.976,355.188 238.5,352.5 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopfrombrazil);
export default __webpack_public_path__ + "static/media/shopfrombrazil.089fb32c1757cc6292a8f15c4afd8e1e.svg";
export { ForwardRef as ReactComponent };